import React from 'react';
import { ListItemSection, ListItemDisplayData } from '../../components/common';

export interface ResidentMenuItem {
  id: number;
  name: string;
  description: string;
}

interface ResidentListProps {
  items: ResidentMenuItem[];
  selectedItemId?: number;
  onSelectItem: (item: ResidentMenuItem) => void;
}

const ResidentList: React.FC<ResidentListProps> = ({
  items,
  selectedItemId,
  onSelectItem
}) => {
  const getDisplayData = (item: ResidentMenuItem): ListItemDisplayData => {
    return {
      title: item.name,
      category: 'Information',
      fields: [
        {
          name: 'Description',
          value: item.description,
          isPrimary: false
        }
      ]
    };
  };

  return (
    <div className="list">
      <div className="list-header">
        <h3>Menu</h3>
      </div>
      
      <ListItemSection
        items={items}
        selectedItemId={selectedItemId}
        onSelectItem={onSelectItem}
        onDeleteItem={() => {}} // No delete functionality
        canDelete={() => false} // No delete buttons
        loading={false}
        loadingMessage=""
        emptyMessage="No information available"
        getDisplayData={getDisplayData}
      />
    </div>
  );
};

export default ResidentList;

